<div class="audit-log-view-changes-dialog">
    <p-table [value]="[data]" [scrollable]="true" scrollHeight="400px">
        <ng-template #header>
            <tr></tr>
            <tr>
                <th scope="col">{{'adminAuditLog.dialog.viewChanges.tableHeader.attribute' | transloco}}</th>
                <th scope="col" class="tw-text-right">{{'adminAuditLog.dialog.viewChanges.tableHeader.before' | transloco}}</th>
                <th scope="col">{{'adminAuditLog.dialog.viewChanges.tableHeader.after' | transloco}}</th>
            </tr>
        </ng-template>
        <ng-template #body>
            <ng-container>
                <tr *ngFor="let change of processedChanges">
                    <td>{{ change.key | underscoreless }}</td>
                    <td>
                        <ng-container *ngIf="globalHelperService.isObject(change.before)">
                            <span *ngFor="let obj of change.before | keyvalue" class="tw-block tw-break-all">
                                <strong>{{ obj.key | underscoreless }}: </strong>
                                <ng-container *ngIf="obj.value !== null && obj.value !== undefined">
                                    <span *ngIf="globalHelperService.isObject(obj.value)">{{obj.value | json}}</span>
                                    <span *ngIf="!globalHelperService.isObject(obj.value)">{{ obj.value | underscoreless }}</span>
                                </ng-container>
                                <span *ngIf="obj.value === null || obj.value === undefined" class="tw-italic">{{'adminAuditLog.dialog.viewChanges.emptyValue' | transloco}}</span>
                            </span>
                        </ng-container>
                        <span class="tw-break-all" *ngIf="!globalHelperService.isObject(change.before) && !created">{{change.before}}</span>
                    </td>
                    <td>
                        <ng-container *ngIf="globalHelperService.isObject(change.after)">
                            <span *ngFor="let obj of change.after | keyvalue" class="tw-block tw-break-all">
                                <strong>{{ obj.key | underscoreless }}: </strong>
                                <ng-container *ngIf="obj.value !== null && obj.value !== undefined">
                                    <span *ngIf="globalHelperService.isObject(obj.value)">{{obj.value | json}}</span>
                                    <span *ngIf="!globalHelperService.isObject(obj.value)">{{ obj.value | underscoreless }}</span>
                                </ng-container>
                                <span *ngIf="obj.value === null || obj.value === undefined" class="tw-italic">{{'adminAuditLog.dialog.viewChanges.emptyValue' | transloco}}</span>
                            </span>
                        </ng-container>
                        <span class="tw-break-all" *ngIf="!globalHelperService.isObject(change.after)">{{change.after}}</span>
                    </td>
                </tr>
            </ng-container>
            <ng-container>
                <tr *ngFor="let relationshipChange of processedRelationshipChanges">
                    <td>{{ relationshipChange.key | underscoreless }}</td>
                    <td>
                        <span *ngFor="let obj of relationshipChange.before" class="tw-block tw-break-all">
                            <ng-container *ngIf="obj.value !== null && obj.value !== undefined">
                                <strong>{{ obj.label | transloco }}: </strong>
                                <span>{{ obj.value | underscoreless }}</span>
                            </ng-container>
                        </span>
                    </td>
                    <td>
                        <span *ngFor="let obj of relationshipChange.after" class="tw-block tw-break-all">
                            <ng-container *ngIf="obj.value !== null && obj.value !== undefined">
                                <strong>{{ obj.label | transloco }}: </strong>
                                <span>{{ obj.value | underscoreless }}</span>
                            </ng-container>
                        </span>
                    </td>
                </tr>
            </ng-container>
        </ng-template>
    </p-table>
</div>